export default __webpack_public_path__ + "static/media/img-slider-lh-career-1.1867ad92.png";